module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Introducing a crusty old codger with a twisted sense of humour, as displayed in the twenty-odd books written by him, some for children; also, hysterically historical tales, others spooky, a few of them gruesome but usually offbeat.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("He is a fit eighty-one-year-old, with a beautiful wife whom he has courted from age sixteen, four adult children, twelve grandchildren and three great-grandchildren. Not forgetting his sister, Pam, whom he loves dearly, and her family. Then there’s Pet’s brother, Tony, his wife, Carol and their large family. When they all get together, it’s a real circus. He loves sport and has played cricket, rugby, tennis, hockey, football, squash, golf, table-tennis, is keen on fishing and car-rallied for many years. But now he’s getting too stiff to tie his shoelaces and finds pleasure in pounding the story-telling keyboard.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0